module.exports = __webpack_public_path__ + "img/vo-740.db306f9a.jpg";